// iter417 — useCompareMode hook.
// Owns the dashboard's "Compare period" toggle: state (period + enabled
// flag + data + loading) plus the fetch effect. Pulled out of
// DashboardPage.jsx so the page no longer carries comparison logic.
//
// Returns the same shape the parent used to expose so the existing
// CompareModeToolbar JSX is a no-op rewire.
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '@/lib/api';

export function useCompareMode({ branchFilter = [] } = {}) {
  const [comparePeriod, setComparePeriod] = useState('day');   // day · week · month
  const [compareEnabled, setCompareEnabled] = useState(false);
  const [compareData, setCompareData] = useState(null);
  const [compareLoading, setCompareLoading] = useState(false);

  useEffect(() => {
    if (!compareEnabled) { setCompareData(null); return; }
    let cancelled = false;
    (async () => {
      setCompareLoading(true);
      try {
        const params = new URLSearchParams({ period: comparePeriod });
        if (branchFilter.length > 0) params.set('branch_ids', branchFilter.join(','));
        const res = await api.get(`/dashboard/period-compare?${params.toString()}`);
        if (!cancelled) setCompareData(res.data);
      } catch {
        if (!cancelled) toast.error('Failed to fetch comparison data');
      } finally {
        if (!cancelled) setCompareLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [compareEnabled, comparePeriod, branchFilter]);

  return {
    comparePeriod, setComparePeriod,
    compareEnabled, setCompareEnabled,
    compareData,
    compareLoading,
  };
}

export default useCompareMode;
